export const CUSTOM_PREFIX = "CUSTOM-";

export const parseOrderProductId = (productId) => {
  let pid = String(productId ?? "");
  if (pid.startsWith(CUSTOM_PREFIX)) {
    return { source: "custom", id: pid.slice(CUSTOM_PREFIX.length) };
  }
  return { source: "asi", id: pid }; // ASI stays numeric/string
};

// NEW: central truth for "is this a custom product?"
export const isCustomProduct = (product) => {
  const { source } = parseOrderProductId(product?.ProductId || "");
  const hasCustomPrefix = source === "custom";

  const savedAsCustom = (product?.Source || "").toLowerCase() === "custom";

  // Your API pattern: internal/custom items have SupplierId === 1 and no ASI number
  const looksInternalSupplier =
    String(product?.SupplierId ?? "") === "1" && !product?.supplier?.AsiNumber;

  return hasCustomPrefix || savedAsCustom || looksInternalSupplier;
};